(() => {
  const setupMarquee = (root) => {
    const viewport = root.querySelector('[data-tk-logos-viewport]');
    const track = root.querySelector('[data-tk-logos-track]');
    if (!viewport || !track) return;

    const originals = Array.from(track.children).filter(
      (el) => el.dataset.tkLogoClone !== '1'
    );
    if (!originals.length) return;

    // Alte Loop-Kopien entfernen
    track.querySelectorAll('[data-tk-logo-clone="1"]').forEach((el) => el.remove());

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    // Auf Mobile / ohne Motion: nur einmal zeigen, manuell scrollen
    if (reduceMotion || isMobile) {
      root.classList.remove('is-marquee');
      return;
    }

    // Kurz ohne Animation messen
    root.classList.remove('is-marquee');
    const needsLoop = track.scrollWidth > viewport.clientWidth + 8;

    if (!needsLoop) return;

    originals.forEach((el) => {
      const clone = el.cloneNode(true);
      clone.dataset.tkLogoClone = '1';
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      track.appendChild(clone);
    });

    root.classList.add('is-marquee');
  };

  const bind = (root) => {
    if (!root || root.dataset.tkLogosBound === '1') return;
    root.dataset.tkLogosBound = '1';

    const pause = () => root.classList.add('is-paused');
    const resume = () => root.classList.remove('is-paused');

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', (event) => {
      if (!root.contains(event.relatedTarget)) resume();
    });

    const refresh = () => setupMarquee(root);
    refresh();

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(refresh, 150);
    });
  };

  const init = () => {
    document.querySelectorAll('[data-tk-logos]').forEach(bind);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('[data-tk-logos]') || event.target.closest?.('[data-tk-logos]');
    if (root) {
      root.dataset.tkLogosBound = '';
      bind(root);
    } else {
      init();
    }
  });
})();
